
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';

import { Link } from "react-router-dom";
import lengyel from "../../assets/lengyel.png";
import magyar from "../../assets/magyar.png";
import arrow from "../../assets/arrow.png"

function LengyelMagyar({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Lengyel magyar fordító</title>
                <meta name='description' content="Ingyenes lengyel magyar fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Lengyel magyar fordító" />
                <link rel="canonical" href="https://online-fordito.hu/lengyel-magyar-fordito" />
            </Helmet>
            <h1>Lengyel magyar fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>

                <div className="sectionhead">
                    <h2>A lengyel nyelvről</h2>
                    <img src={lengyel} alt="lengyel zászló"></img>
                </div>

                <p>A lengyel egy nyugati szláv nyelv, amelyet körülbelül 40 millió ember beszél Lengyelországban és a lengyel közösségek világszerte. Lengyelország hivatalos nyelve és az Európai Unió egyik hivatalos nyelve.</p>

                <p>A lengyel nyelv hasonlóságokat mutat más szláv nyelvekkel, például a cseh, a szlovák és az orosz nyelvvel. Ugyanakkor sajátos jellegzetességei, szókincse és kiejtése is van.</p>

                <p>Írásrendszere a latin ábécét használja, néhány további diakritikus jellel, köztük ékezetekkel és orrhangzókkal. A rendszer 32 betűből áll, beleértve az olyan különleges karaktereket is, mint a ą, ć, ł, ś és ż. A lengyel kiejtés általában fonetikus, a helyesírás és a hangok közötti megfelelés szabályos.</p>

                <p>Nyelvtanára jellemző a főnév deklinációk, igekötők és nyelvtani nemek összetett rendszere. A főnevek, melléknevek és névmások a nyelvtani funkciótól, számtól és nemtől függően változtatják a végződésüket. A lengyel nyelvben hét eset van, köztük az alanyeset, az akkuzatív, a genitivus, a dativus, az instrumentális, a lokatívus és a vokatívus.</p>

                <p>A lengyel szókincs eredeti lengyel szavak és más nyelvekből, elsősorban latinból, németből, franciából és angolból származó kölcsönszavak keveréke. A nyelv gazdag irodalmi hagyományokkal rendelkezik, és olyan neves lengyel írók és költők, mint Adam Mickiewicz, Wisława Szymborska és Czesław Miłosz hozzájárultak a nyelv kulturális gazdagságához.</p>

                <p>A lengyel kultúra és történelem szorosan kötődik a nyelvhez. A lengyel nyelv tanulása betekintést nyújt Lengyelország gazdag örökségébe, beleértve a hagyományokat, a folklórt, a zenét és a művészetet. Emellett elősegíti a lengyel társadalom, szokások és értékek mélyebb megértését.</p>

                <p>Lengyelország az Európai Unió tagja, és növekvő gazdasággal rendelkezik, így a nyelvtudás előnyös az üzleti életben, a kereskedelemben és a nemzetközi kapcsolatokban. A nyelvtudás azok számára is értékes, akik a tudományos életben, a kutatásban, a fordításban vagy a lengyel nyelvű közösségekben való munkavégzésben érdekeltek.</p>

                <div className="sectionbottom">
                    <Link to="/magyar-lengyel-fordito">Magyar lengyel fordító</Link>

                    <img src={lengyel} alt="lengyel zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>

                </div>
            </section>
        </>

    )
}

export default LengyelMagyar;